import { DepartmentRow } from 'components/tables/data/department/types';
import P3Regular from 'components/typography/P3Regular';

/**
 * Column for the department id.
 */
export default function DepartmentIdColumn({ data: { departmentId } }: { data: DepartmentRow }) {
  return <P3Regular color="gray.8">{departmentId}</P3Regular>;
}
